import { BaseModel, attr, belongsTo } from "../../lib/itn-ui-kit/data";

export default class ClientCoverageModel extends BaseModel {
  static urlPath = "client_coverage";

  @attr("number") relatedCase;
  @attr("number") coverageStatus;
  @attr("number") liabilityRequestStatus;
  @attr("number") liabilityStatus;
  @attr("string") createdAt;
  @attr("string") updatedAt;
  @attr("string") coverageNote;
  @attr("string") liabilityNote;
  @attr("string") liabilityRequestEmail;
  @belongsTo("user") updatedBy;
  @belongsTo("user") createdBy;
}
